module.exports = __webpack_public_path__ + "assets/img/eCard-qr-middle.b0ece984.png";